import {
  Box, Grid, Typography,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { useIsLargeScreen } from '../../common/hooks/useResponsive';
import { AppOptimizelyProvider } from '../../config/AppOptimizelyProvider';
import { useLogo } from '../../config/useLogo';
import { RegistrationSignUp } from './RegistrationSignUp';
import { RegistrationComplete } from './RegistrationComplete';

export default function SignUpLayout() {
  const theme = useTheme();
  const isDesktop = useIsLargeScreen();
  const { t } = useTranslation();
  const { loginImage } = useLogo();
  const [searchParams] = useSearchParams();
  const emailInput = searchParams.get('email');
  const registrationCodeParam = searchParams.get('registrationCode');
  const memberEmailParam = searchParams.get('memberEmail');
  const showRegistrationComplete = Boolean(registrationCodeParam && memberEmailParam);

  const registrationContent = showRegistrationComplete ? (
    <RegistrationComplete
      registrationCode={registrationCodeParam as string}
      memberEmail={memberEmailParam as string}
      firstName={searchParams.get('firstName') || undefined}
      lastName={searchParams.get('lastName') || undefined}
      companyName={searchParams.get('companyName') || undefined}
    />
  ) : (
    <RegistrationSignUp email={emailInput || undefined} />
  );

  const formContent = (
    <Grid container spacing={{ xs: 2 }}>
      <Grid
        item
        xs={6}
        sx={{
          textAlign: 'center',
          marginLeft: theme.spacing(0),
          marginRight: theme.spacing(0),
          background: theme.palette.common.white,
        }}
      >
        {registrationContent}
      </Grid>
      <Grid
        item
        xs={6}
        sx={{
          paddingTop: ` ${theme.spacing(0)} !important`,
          marginLeft: theme.spacing(0),
          marginRight: theme.spacing(0),
          background: theme.palette.grey[100],
        }}
      >
        <Box
          display="flex"
          flexDirection={'column'}
          sx={{
            height: '100vh',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography
            variant="h12"
            sx={{
              mb: theme.spacing(8),
            }}
          >
            {t('login.imageHeading')}
          </Typography>
          <img
            src={loginImage as string}
            alt={'login_page_logo'}
          />
        </Box>
      </Grid>
    </Grid>
  );

  return (
    <AppOptimizelyProvider>
      <Box sx={{ background: theme.palette.common.white }}>
        {isDesktop ? formContent : registrationContent}
      </Box>
    </AppOptimizelyProvider>
  );
}
